export default "https://assets.stage.yurplan.com/yurplan-v1/dist/eye-hidden.3825ebe85209dae480693b3b23a2758e.svg";